const sharedIconCss = {
  path: {
    fill: "currentColor",
  },
};

export const googleClassroomIconCss = {
  rect: {
    stroke: "currentColor",
  },
  "circle, path": {
    fill: "currentColor",
  },
};

export const linkIconCss = {
  path: {
    stroke: "currentColor",
  },
};

export const facebookIconCss = sharedIconCss;

export const envelopeIconCss = {
  "rect, path": {
    stroke: "currentColor",
  },
};

export const pinterestIconCss = sharedIconCss;

export const remindIconCss = sharedIconCss;
